// ===================================================
// GAM Command Center — Table Extensions
// Wraps @tiptap/extension-table with GAM classes
// Requires: npm install @tiptap/extension-table
//           @tiptap/extension-table-row
//           @tiptap/extension-table-cell
//           @tiptap/extension-table-header
// ===================================================

import { Table } from '@tiptap/extension-table';
import { TableRow } from '@tiptap/extension-table-row';
import { TableCell } from '@tiptap/extension-table-cell';
import { TableHeader } from '@tiptap/extension-table-header';

export const GamTable = Table.configure({
  resizable: true,
  HTMLAttributes: { class: 'gam-table' },
});

export const GamTableRow = TableRow.configure({
  HTMLAttributes: { class: 'gam-table__row' },
});

/**
 * Vertical placement inside a cell.
 *
 * Gal, 2026-09-07: «איפה התוכן ישב מבחינת מרכז הטבלה או פינה שמאל עליון או
 * פינה ימין תחתון». Horizontal placement is textAlign and already existed;
 * the missing half is the vertical one, and vertical placement only means
 * something inside a box that has a height — a table cell today, a column
 * block next. So it lives on the cell, not on the paragraph.
 */
const verticalAlignAttribute = {
  verticalAlign: {
    default: null as string | null,
    parseHTML: (element: HTMLElement) => element.style.verticalAlign || null,
    renderHTML: (attributes: Record<string, unknown>) =>
      attributes.verticalAlign
        ? { style: `vertical-align: ${attributes.verticalAlign}` }
        : {},
  },
};

export const GamTableCell = TableCell.extend({
  addAttributes() {
    return { ...this.parent?.(), ...verticalAlignAttribute };
  },
}).configure({
  HTMLAttributes: { class: 'gam-table__cell' },
});

export const GamTableHeader = TableHeader.extend({
  addAttributes() {
    return { ...this.parent?.(), ...verticalAlignAttribute };
  },
}).configure({
  HTMLAttributes: { class: 'gam-table__header' },
});

// Export all table extensions as array for easy import
export const tableExtensions = [GamTable, GamTableRow, GamTableCell, GamTableHeader];
